/* src/app/modules/dna-syngovia/components/dna-syngovia-group-table-list/dna-syngovia-group-table-list.component.scss */
:host {
  display: block;
  box-shadow: 0 0.125rem 0.5rem rgba(0, 0, 0, 0.2);
}
.table-container {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  background-color: var(--base-3);
  align-items: stretch;
  position: relative;
}
.table-container sh-spinner {
  position: absolute;
  background-color: rgba(var(--ui-7), var(--opacity-2));
  padding-top: 10rem;
  box-sizing: border-box;
  justify-content: start;
  z-index: 2;
}
.table-container div.table-wrapper {
  margin: 0 1rem 1rem 1rem;
  overflow-x: auto;
}
.table-container div.table-wrapper sh-table {
  height: auto;
  min-width: fit-content;
  width: 100%;
}
.table-container div.table-wrapper .table-fixed-height {
  height: 34.0625rem;
}
.table-container div.table-wrapper sh-table-cell {
  text-align: start;
}
.table-container__description {
  margin: 1rem;
}
.table-container__description div.description {
  font: var(--header-2);
  font-size: 1.125rem;
}
.table-container__description div > img {
  width: 2.75rem;
  height: 2.75rem;
}
.search-container sh-input-text {
  width: 260px;
}
.search-container sh-icon[icon=filter] {
  color: rgb(var(--ui-5));
}
.flex-row {
  display: flex;
  flex-wrap: nowrap;
  gap: var(--gap);
  align-items: center;
}
.flex--jc-sb {
  justify-content: space-between;
}
.flex--wrap {
  flex-wrap: wrap;
}
.icons-wrapper {
  display: flex;
  gap: 0.5rem;
}
.warning-icon-wrapper {
  width: 1.5rem;
  height: 1.5rem;
  align-self: center;
}
.modal-header {
  width: 100%;
  padding: 1rem;
  background: rgba(0, 0, 0, 0.05);
  display: flex;
  justify-content: space-between;
}
.modal-header sh-text {
  line-height: 1.75rem;
}
.modal-header sh-button {
  width: fit-content;
  padding: 0.25rem 1.625rem;
}
.nested-header-cell {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.nested-header-cell--line-height {
  line-height: 0.875rem;
}
.nested-header-cell div:last-child {
  color: var(--ui-ui-1-opacity-3, var(--text-secondary, rgba(0, 0, 0, 0.6)));
}
sh-table-cell.checkbox,
sh-table-cell.nested-cell.checkbox,
sh-table-row.nested sh-table-cell.nested-cell {
  padding-left: calc(var(--sh-table-cell-first-nested-padding) + var(--sh-table-cell-nested-padding) * var(--nesting-level) + 3rem);
}
sh-table-head.first-header-cell-checkbox {
  padding-left: calc(var(--sh-table-head-padding-left) + 1.5rem);
}
sh-table-head.first-header-cell-checkbox.syngovia-nested {
  padding-left: calc(var(--sh-table-head-padding-left) + 3.875rem);
}
.table-loader-spinner {
  align-self: center;
}
.pointer {
  cursor: pointer;
}
/*# sourceMappingURL=dna-syngovia-group-table-list.component.css.map */
